let handleWindowPrint = (ele, fileName, vm) => {
    console.log(ele,fileName)
    var oIframe = document.createElement('iframe');
    var oScript = document.createElement('script');

    document.body.appendChild(oIframe);
    // var titleText = document.head.getElementsByTagName('title')[0].innerText;
    // document.head.getElementsByTagName('title')[0].innerText = `${fileName}`;

    oIframe.contentDocument.head.innerHTML = `<meta charset="utf-8">
                                            <title style="display:none;">${fileName}</title>
                                            <meta name="format-detection" content="telephone=no">
                                            <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
                                            <meta name="viewport" content="width=device-width,initial-scale=1.0"><style>#account-report{color:#3a3030;margin:0 auto;width:1000px;background:pink;padding:30px;background:#ffffff;font-size:12px}#account-report table{border:none}#account-report table tbody{border:1px solid #3a3030}#account-report table,#account-report th,#account-report td{border:1px solid #3a3030}#account-report .table-list{width:100%}#account-report .table-list .title{font-size:14px;font-weight:500}#account-report .table-list .sub-title{text-align:left}#account-report .table-list th{height:30px;line-height:30px;font-weight:400}#account-report .table-list .no-border th{border:none}#account-report .tw1{width:5%}#account-report .tw2{width:10%}#account-report .tw3{width:15%}#account-report .tw4{width:20%}#account-report .tw5{width:25%}#account-report .tw6{width:30%}#account-report .tw5{width:35%}#account-report .tw8{width:40%}#account-report .tw9{width:45%}#account-report .tw10{width:50%}#account-report .text-left{text-align:left;text-indent:8px}
                                            </style>`;

    // oIframe.contentWindow.document.body.innerHTML = document.querySelector(ele).outerHTML;
    oIframe.contentDocument.body.innerHTML = document.querySelector(ele).outerHTML;
    oScript.innerHTML = 'window.print();';
    oIframe.contentDocument.body.appendChild(oScript);
    document.body.removeChild(oIframe);
    // document.head.getElementsByTagName('title')[0].innerText = titleText;

};

export default {
    handleWindowPrint
}